import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { useTranslation } from 'react-i18next';

const LanguagesField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t: tForm } = useTranslation('form');
	const languages = restaurantForFullInfo?.restaurantLanguages.map((el) => tForm(el.languageName || '')).join(', ');

	return <FullInfoField label="languagesLabel" value={languages} />;
};

export default LanguagesField;
